<template>
  <div>
    <p class="sub-title">备注信息</p>
    <p class="tips">设置付款时顾客需填的信息，比如姓名、手机号等，可以选择合适的组件</p>
    <ul class="notes-list">
      <el-form :model="item" :rules="formRules(index)" ref="form" v-for="(item, index) in notesList" :key="index">
        <el-form-item prop="title" :label="`${index + 1}`" label-width="30px">
          <li class="item">
            <div class="flex flex-center">
              <el-input
                v-model="item.title"
                class="common-input"
                placeholder="请输入备注标题，尽量精简最多20字"
                :maxlength="20"
                clearable/>
              <el-select v-model="item.selectType" class="type-select">
                <el-option label="文本输入框" :value="0"/>
                <el-option label="单选" :value="1"/>
                <el-option label="多选" :value="2"/>
              </el-select>
              <el-select v-model="item.requiredFlag" class="required-select">
                <el-option label="非必填" :value="0"/>
                <el-option label="必填" :value="1"/>
              </el-select>
              <div class="item-btn" @click="removeNote(index)">
                <img class="icon" src="../../assets/images/flow/remove.png" alt="移除备注">
                <span class="text">删除</span>
              </div>
              <div v-show="index>0" class="item-btn" @click="upNote(index)">
                <img class="icon" src="../../assets/images/flow/up.png" alt="上移备注">
                <span class="text">上移</span>
              </div>
              <div v-show="index < notesList.length-1" class="item-btn" @click="downNote(index)">
                <img class="icon" src="../../assets/images/flow/down.png" alt="下移备注">
                <span class="text">下移</span>
              </div>
            </div>
            <div v-show="item.selectType !== 0" class="options-wrapper">
              <p class="option-title">{{ item.selectType === 1 ? "单" : "多" }}选选择项</p>
              <ul class="options-list">
                <li v-for="(optionItem, optionIndex) in item.options || []" :key="optionIndex" class="flex flex-center">
                  <el-input
                    v-model="item.options[optionIndex]"
                    class="common-input"
                    placeholder="请输入选项内容，尽量精简最多20字"
                    clearable
                    :maxlength="20"/>
                  <img
                    v-show="item.options.length > 1"
                    class="remove-icon"
                    src="../../assets/images/flow/remove.png"
                    alt="移除选项"
                    @click="removeOption(index, optionIndex)">
                </li>
              </ul>
              <div v-show="item.options.length < 100" class="add-view flex flex-center" @click="addOption(index)">
                <img class="add-icon" src="../../assets/images/flow/add.png" alt="添加选项">
                <span class="text">添加选项</span>
              </div>
            </div>
          </li>
        </el-form-item>
      </el-form>
      <li class="item">
        <div class="flex flex-center">
          <span class="no">{{ notesList.length + 1 }}</span>
          <el-input
            disabled
            v-model="remark.title"
            class="common-input"
            placeholder="请输入备注标题，尽量精简最多20字"
            :maxlength="20"
            clearable/>
          <el-select v-model="remark.selectType" class="type-select" disabled>
            <el-option label="文本输入框" :value="0"/>
            <el-option label="单选" :value="1"/>
            <el-option label="多选" :value="2"/>
          </el-select>
          <el-select v-model="remark.requiredFlag" class="required-select" disabled>
            <el-option label="非必填" :value="0"/>
            <el-option label="必填" :value="1"/>
          </el-select>
        </div>
      </li>
    </ul>
    <div class="bottom-view" v-show="notesList.length + 1 < notesLimit">
      <p class="limit ">点击添加备注组件({{ notesList.length + 1 + '/' + notesLimit }})</p>
      <div>
        <el-button class="add-note-btn" @click="addNote(0)">文本输入框</el-button>
        <el-button class="add-note-btn" @click="addNote(1)">单选</el-button>
        <el-button class="add-note-btn" @click="addNote(2)">多选</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "manuallyCreate",
  data() {
    return {
      addImgUrl: require("../../assets/images/flow/add.png"),
      removeImgUrl: require("../../assets/images/flow/remove.png"),
      upImgUrl: require("../../assets/images/flow/up.png"),
      downImgUrl: require("../../assets/images/flow/down.png"),
      notesList: [],
      notesLimit: 10,
      noteTypeOptions: [{ value: 1, label: "文本输入框" }, { value: 2, label: "单选" }, { value: 3, label: "多选" }],
      requiredOptions: [{ value: 1, label: "非必填" }, { value: 2, label: "必填" }],
      remark: {
        title: "备注", selectType: 0, requiredFlag: 0, options: ["", "", ""],
      },
    };
  },
  props: {
    /* 收款单金额类型 */
    type: {
      type: Number,
      default: 0,
    },
    templateType: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    formRules() {
      return (index) => {
        const selectValidFunc = (rule, value, callback) => {
          if ([1, 2].includes(this.notesList[index].selectType) && this.notesList[index].options.some(i => i === '')) {
            callback(new Error('请输入选项值'));
          } else {
            callback();
          }
        };
        return {
          title: [
            { required: true, message: '请输入备注标题', trigger: ['blur', 'change'] },
            { validator: selectValidFunc },
          ],
        };
      };
    },
  },
  methods: {
    init() {
      switch (this.templateType) {
        case 1:
          this.notesList = [
            {
              title: "姓名", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
            {
              title: "课程名称", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
          ];
          break;
        case 2:
          this.notesList = [
            {
              title: "业主姓名", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
            {
              title: "楼道号", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
            {
              title: "门牌号", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
          ];
          break;
        case 3:
          this.notesList = [
            {
              title: "学生姓名", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
            {
              title: "年级", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
            {
              title: "班级", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
            {
              title: "学号", selectType: 0, requiredFlag: 1, options: ["", ""],
            },
          ];
          break;
        default:
          this.notesList = [
            {
              title: "", selectType: 0, requiredFlag: 0, options: ["", ""],
            },
            {
              title: "", selectType: 1, requiredFlag: 0, options: ["", ""],
            },
            {
              title: "", selectType: 2, requiredFlag: 0, options: ["", ""],
            },
          ];
          break;
      }
    },
    getListParam() {
      return Promise.all(this.$refs.form.reduce((arr, item) => {
        item.validate(valid => arr.push(valid));
        return arr;
      }, [])).then((valid) => {
        if (valid.every(i => i)) {
          return [
            ...this.notesList.map((item, index) => {
              const data = {
                sortBy: index,
                title: item.title,
                requiredFlag: item.requiredFlag,
                type: item.selectType,
              };
              let remarkOptionsList = [];
              if (item.selectType !== 0) {
                remarkOptionsList = item.options.map(option => ({ content: option }));
              }
              data.remarkOptionsList = remarkOptionsList;
              return data;
            }),
            {
              sortBy: this.notesList.length + 1,
              title: this.remark.title,
              requiredFlag: this.remark.requiredFlag,
              type: this.remark.selectType,
            },
          ];
        }
        return [];
      });
    },
    removeOption(index, optionIndex) {
      this.notesList[index].options.splice(optionIndex, 1);
    },
    addOption(index) {
      this.notesList[index].options.push('');
    },
    addNote(selectType) {
      this.notesList.push({
        title: "",
        selectType,
        requiredFlag: 0,
        options: ["", ""],
      });
    },
    removeNote(index) {
      this.notesList.splice(index, 1);
    },
    upNote(index) {
      const item = this.notesList[index];
      this.notesList.splice(index, 1, this.notesList[index - 1]);
      this.notesList.splice(index - 1, 1, item);
    },
    downNote(index) {
      const item = this.notesList[index];
      this.notesList.splice(index, 1, this.notesList[index + 1]);
      this.notesList.splice(index + 1, 1, item);
    },
  },
};
</script>

<style scoped lang="scss">
.sub-title {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.tips {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

.notes-list {
  margin-top: 20px;
}

.no {
  margin-right: 20px;
}

.type-select {
  width: 130px;
  margin-right: 10px;
}

.required-select {
  width: 100px;
}

.common-input {
  width: 380px;
  margin-right: 10px;
}

.item-btn {
  display: flex;
  align-items: center;
  margin-left: 24px;
  cursor: pointer;

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .text {
    font-size: 14px;
    color: #008cff;
  }
}

.bottom-view {
  .limit {
    margin-top: 10px;
    margin-bottom: 18px;
    font-size: 14px;
    color: #303133;
  }

  .add-note-btn {
    color: #008cff;
    background-color: #fff;
    border-color: #008cff;
  }
}

.options-wrapper {
  .option-title {
    margin-top: 16px;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 1;
    color: #303133;
    text-indent: 28px;
  }

  .options-list {
    padding-left: 28px;

    > li {
      margin-bottom: 20px;
    }

    .remove-icon {
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }

  .add-view {
    padding-left: 28px;
    cursor: pointer;

    .add-icon {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }

    .text {
      font-size: 14px;
      line-height: 1;
      color: #008cff;
    }
  }
}

/deep/ .el-form {
  .el-form-item__content {
    display: flex;

    .el-form-item__error {
      position: relative;
      padding-top: 0;
      padding-left: 50px;
      line-height: 40px;
    }
  }
}
</style>
